import { Value } from "../types";

const addZeroToTime = (time: number) => {
  if (time < 10) {
    return `0${time}`;
  }
  return time;
};

export const formatExtendedDate = (date: Value): string => {
  if (date instanceof Date) {
    const dateFormatOptions: Intl.DateTimeFormatOptions = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };

    const formatOfDate = new Intl.DateTimeFormat("pt-BR", dateFormatOptions);
    const dataFormatada = formatOfDate.format(date);

    return dataFormatada;
  }

  return "";
};

export const formatHours = (date: string): string => {
  const newDate = new Date(date);

  let formattedHour = `${addZeroToTime(newDate.getHours())}${
    newDate.getMinutes() ? `:${addZeroToTime(newDate.getMinutes())}` : ":00"
  }`;

  return formattedHour;
};

export const getParamSearch = (paramName: string = "q"): string => {
  const oldUrl = new URL(window.location.href);
  const paramsSearch = new URLSearchParams(oldUrl.search);

  return paramsSearch.get("q") || "";
};

export const formatURL = (
  url: string,
  currentPage: number,
  itemsPerPage: number,
  orderBy: string,
  selectedTypes: string[]
): string => {
  let filter = `contains(title, '${getParamSearch()}')`;
  let fields = "title,friendlyUrlPath,datePublished";
  let filterTypes = "";

  if (selectedTypes.length > 0) {
    selectedTypes.forEach((type, index) => {
      if (index === 0) {
        filterTypes = `contains(friendlyUrlPath, '${type}')`;
      } else {
        filterTypes = `${filterTypes} or contains(friendlyUrlPath, '${type}')`;
      }
    });

    filter = `${filter} and (${filterTypes})`;
  }

  const newUrl = new URL(url);
  const params = new URLSearchParams(newUrl.search);

  newUrl.searchParams.set("filter", filter);
  newUrl.searchParams.set("fields", fields);
  newUrl.searchParams.set("flatten", "true");
  newUrl.searchParams.set("page", currentPage.toString());
  newUrl.searchParams.set("itemsPerPage", itemsPerPage.toString());
  if (orderBy !== "")
    newUrl.searchParams.set(
      "sort",
      `${orderBy.split(",")[0]}:${orderBy.split(",")[1]}`
    );

  return newUrl.toString();
};

export const removeLeadingSlash = (url: string): string => {
  if (url.startsWith("/")) {
    return url.slice(1);
  }
  return url;
};

export const formatCategory = (url: string): string => {
  let newUrl = removeLeadingSlash(url);

  if (/\d/.test(newUrl.split("/")[0]) || newUrl.length > 25) {
    return "conteúdo web";
  }

  return decodeURIComponent(newUrl.split("/")[0]).replace(/[-_]/g, " ");
};

export const limitText = (text: string, maxSize: number): string => {
  if (text.length > maxSize) {
    return text.slice(0, maxSize) + "...";
  } else {
    return text;
  }
};
